<template>
  <div>
    <a
      :href="listing.url"
      class="relative block flex-shrink-0"
      style="width: 160px"
      :title="`${listing.title} by ${listing.artist.full_name} in ${listing.dimensions_short}, ${listing.medium.title}`"
      target="_blank"
    >
      <div class="bg-gray-100 overflow-hidden w-full h-[160px]">
        <img
          class="mx-auto w-full h-full object-cover lazyload transition-transform ease-in-out duration-700 hover:scale-110"
          :src="listing.images.artwork.portfolio"
          :alt="`${listing.title} by ${listing.artist.full_name} in ${listing.dimensions_short}, ${listing.medium.title}`"
        />
      </div>

      <div class="py-4">
        <div class="text-sm text-zinc-700 capitalize line-clamp-1">
          {{ listing.title | truncate(29, "...") }}
        </div>
        <div class="flex items-center justify-between">
          <span class="text-zinc-400 text-sm capitalize line-clamp-1">
            {{ listing.artist.full_name }}
          </span>
        </div>

        <div class="justify-between flex items-center mt-5">
          <span class="font-bold text-zinc-900 text-sm">
            <template v-if="listing.price_with_discount">
              <div>{{ listing.price_with_discount.format }}</div>
              <div class="text-xs mt-2">
                <span class="font-normal line-through text-red-600 mr-4">{{ listing.price.format }}</span>
                <span class="bg-red-600 text-white p-2 rounded-md">{{
                  listing.discount_percentage | discountLabel
                }}</span>
              </div>
            </template>
            <template v-else>
              {{ listing.price.format }}
            </template>
          </span>
          <span><Favourite :listing="listing" :guestFavourites="guestFavourites" /></span>
        </div>
      </div>
    </a>
    <AddCartBtn
      containerClass="mt-6"
      :listingId="listing.id"
      :checkoutPath="checkoutPath"
      viewCartClass="hidden btn-sm btn-primary rounded-lg"
      addCartClass="w-full py-4 btn-sm btn-default-primary rounded-lg"
    />
  </div>
</template>

<script>
import AddCartBtn from "@/components/Listing/AddCartBtn.vue"
import Favourite from "@/components/Listing/Favourite.vue"
export default {
  name: "Listing.RecentViewItem",
  props: {
    listing: {
      type: Object,
      required: true,
      default: {},
    },
    checkoutPath: {
      type: String,
      required: true,
    },
    guestFavourites: {
      type: [],
      required: false,
      default: [],
    },
  },
  components: {
    AddCartBtn,
    Favourite,
  },
}
</script>
